<template>
  <div class="appHouseholdManage">
     <!-- tab -->
    <div class="filters">
      <el-tag class="tabs" :effect="type==1?'dark':'light'" @click="changeTabs(1)">物业费应收统计</el-tag>
      <el-tag class="tabs" :effect="type==2?'dark':'light'" @click="changeTabs(2)">车位费应收统计</el-tag>
    </div>
    <div class="filters">
      <el-form :inline="true">
        <!-- 选择日期 -->
        <el-form-item :label="$t('lang.lab_receivePeriod')">
          <el-date-picker  type="month" :placeholder="$t('lang.lab_startDate')"   value-format="timestamp" v-model="startTime"></el-date-picker>
            <span style="padding: 0 1px">至</span>
          <el-date-picker  type="month" :placeholder="$t('lang.lab_endDate')"  value-format="timestamp" v-model="endTime" ></el-date-picker>
        </el-form-item>
        <el-switch style="margin-left: 10px; margin-right: 10px;" v-if="isRelationButton==1" active-text="收费减免" v-model="switchValue"> </el-switch>
        <!-- 关键字 -->
        <el-button type="primary" @click="submit()">{{$t('lang.btn_search')}}</el-button>
      </el-form>
    </div>
    <el-card>
      <el-button type="primary" slot="header" @click="excelDownloadClick">{{$t('lang.btn_excelDl')}}</el-button>
      <el-table
        :data="tableData"
        class="wid100"
        :height="tableData.length > 0 ? require('@/config/enum').tableheight529 : require('@/config/enum').tableheight109"
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
      >
        <!-- checkbox -->
        <el-table-column type="selection" width="55" v-if="appHouseholdManageListcheckbox"></el-table-column>
        <!-- 序号 -->
        <el-table-column
          type="index"
          :index="indexMethod"
          align="center"
          :label="$t('lang.lab_index')"
          width="130"
        ></el-table-column>
        <!-- 收费项名称 -->
        <el-table-column  prop="fee_name" :label="$t('lang.lab_feeName')"></el-table-column>
        <!-- 物业费标准元/㎡ -->
        <el-table-column v-if="this.type==1" prop="square_price"  :label="$t('lang.lab_feeStandard')"></el-table-column>
        <el-table-column v-else="this.type==2" prop="additional_amount"  :label="$t('lang.lab_carStandard')"></el-table-column>
        <!-- 面积㎡-->
        <el-table-column v-if="this.type==1" prop="BuildAreaCount" :label="$t('lang.lab_buildArea')">
          <template slot-scope="scope">{{scope.row.BuildAreaCount|rounding}}</template>
        </el-table-column>
         <el-table-column v-else="this.type==2" prop="carCount" :label="$t('lang.lab_carPlaceCount')">
          <template slot-scope="scope">{{scope.row.carCount}}</template>
        </el-table-column>
        <!-- 金额元 -->
        <el-table-column prop="receiveAmountCount" :label="$t('lang.lab_AmountYuan')">
          <template slot-scope="scope">{{scope.row.receiveAmountCount|rounding}}</template>
        </el-table-column>
      </el-table>
    
    </el-card>

    
  </div>
</template>

<script>
  import {
    excelDownload
  } from '../../../config/download.js'
/**
 *@ClassName:
 *@Description
 *@author:xubz
 *@Copyright:格众科技
 *@date:2021
 */
export default {
  data() {
    return {
      isRelationButton:this.$store.getters.isRelationButton,
      switchValue:false,
      multipleSelection: [], // 多选框
      editableTabs: [], // tabs列表
      datevalues: [], // 开始结束时间绑定值
      houseId: '', // 楼层绑定值
      floorList: [], // 楼层下拉列表
      unitid: '', // 单元绑定值
      unitList: [], // 单元下拉列表
      roomid: '', // 房间绑定值
      roomList: [], // 房间下拉列表
      user: '0', // 身份
      tag: '0', // 标签
      keyword: '', // 手机或序号内容input
      pageCount: 0, // 总页数
      pageNo: 1, // 第几页
      pageSize: 10, // 每页显示数
      tableData: [], // 列表数组
      type: 1, // 楼号单元号房间号区分
      parentId: '',
      gardenId: '', // 小区编号
      appHouseholdManageListcheckbox: require('@/config/enum')
      .appHouseholdManageListcheckbox, // 是否隐藏复选框
      receiveAmountCount: '',
      revAmountCount: '',
      paidAmountCount: '',
      receiveArrearSelect: '0',
      startTime: '',
      endTime: '',
      feeReceiveConfigs:[],
      detail: this.$i18n.t('lang.feePay'), // 列表数据 xu
      configId:''
    }
  },
  created() {
    // 小区编号
    this.gardenId = this.$store.getters.gardenId
    this.getDatePicker()
    // 初始化
    this.topics()
    // 获取楼号
    this.editableTabs = this.$store.getters.getTabList
  },
  // 监听改变小区编号
  watch: {
    '$store.state.allGardenId': function (newFlag, oldFlag) {
      this.gardenId = this.$store.state.allGardenId
    },
    '$store.state.tabList': function (newFlag, oldFlag) {
      this.editableTabs = this.$store.getters.getTabList
    },
  },
  methods: {
    excelDownloadClick() {
      debugger
        if (navigator.onLine) {
          // Excel表头
          if(this.type==1){
            const tHeader = [
            this.$i18n.t('lang.lab_feeName'),
            this.$i18n.t('lang.lab_feeStandard'),
            this.$i18n.t('lang.lab_buildArea'),
            this.$i18n.t('lang.lab_AmountYuan'),
            ]
          const filterVal = ['fee_name', 'square_price', 'BuildAreaCount', 'receiveAmountCount']
          excelDownload(tHeader, filterVal, this.tableData, "应收统计表")
          }else{
            const tHeader = [
            this.$i18n.t('lang.lab_feeName'),
            this.$i18n.t('lang.lab_carStandard'),
            this.$i18n.t('lang.lab_carPlaceCount'),
            this.$i18n.t('lang.lab_AmountYuan'),
            ]
            const filterVal = ['fee_name', 'additional_amount', 'carCount', 'receiveAmountCount']
            excelDownload(tHeader, filterVal, this.tableData, "应收统计表")
          }
        // 对应table数据的列字段名
        } else {
          this.$message.error(this.$i18n.t('lang.lab_Online'))
        }
      },
      // 切换tab
      changeTabs(index) {
        this.type = index
        this.pageNo = 1
        this.pageSize = 10
        this.topics()
      },
    // 初始化时间组件
    getDatePicker() {
       let d = new Date()
      let year1, month1, day1
      [year1, month1, day1] = [d.getFullYear(), d.getMonth() + 1, 0]
      let date1 = new Date(year1, month1, day1).getTime()
      // this.datevalues.push(Date.parse(date1))
      this.endTime = date1
      // 前一天设定的日期时间
      let year2, month2, day2
      [year2, month2, day2] = [d.getFullYear(), d.getMonth(), 1]
      let date2 = new Date(year2, month2, day2).getTime()
      // this.datevalues.unshift(Date.parse(date2))
       this.startTime = date2
    },
    // ID序号功能
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
    // 列表斑马线
    tableRowClassName({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    // 添加多选框
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    topics() {
      var startTs = ''
      var endTs = ''
      var configId=this.configId
      if(this.startTime!=''&&this.startTime!=null&&this.startTime!=undefined){
           startTs =this.startTime
      }else{
           this.$message.info('应收区间不能为空')
          return
      }
       if(this.endTime!=''&&this.endTime!=null&&this.endTime!=undefined){
           endTs =this.endTime
      }else{
          this.$message.info('应收区间不能为空')
          return
      }
      let loading = this.$loading()
      this.$get(
        `/feeReceivableListByGardenId?gardenId=${this.gardenId}&configId=${configId}&startTs=${startTs}&endTs=${endTs}&type=${this.type}&isWaiver=${this.switchValue}`
      ).then(
        (res) => {
          loading.close()
          if (res && res.errCode === 0) {
            console.log(res.list)
            this.tableData = res.list
          }
        },
        (error) => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 提交
    submit() {
      this.pageNo = 1
      this.topics()
    },
    // 通过楼层选择单元号
    selectUnit() {
      this.type = 2
      this.gardenGrids(this.houseId)
      this.unitid = ''
      this.roomid = ''
    },
    // 通过单元选择房间号
    selectRoom() {
      this.type = 3
      this.gardenGrids(this.unitid)
      this.roomid = ''
    },
    // 翻页
    handleCurrentChange(val) {
      this.pageNo = val
      this.topics()
    },
    // 切换每页显示多少数据
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.topics()
    },
  },
  filters: {
    rounding (value) {
      if (value == undefined || value == '') {
          value = 0
      }
     return value.toFixed(2)
    }
  }
}
</script>

<style lang= 'scss'>
  .tabs {
    font-size: 18px;
    margin-right: 20px;
  }
</style>
